import { getRuntimeApiBaseUrl } from '../config';

export function isRemoteAvatar(avatar) {
  return typeof avatar === 'string' && /^https?:\/\//i.test(avatar.trim());
}

export function getAvatarUrl(avatar, version) {
  if (!avatar) return null;
  const value = String(avatar).trim();
  if (isRemoteAvatar(value)) return value;
  const base = getRuntimeApiBaseUrl();
  const qs = version ? `?v=${encodeURIComponent(version)}` : '';
  const path = `/api/users/avatar/${encodeURIComponent(value)}${qs}`;
  return base ? `${base}${path}` : path;
}
